import debug from 'debug';
import { Base } from '@fus078/components/base-behaviour';
const log = debug('fus078/components/video-block');


export class videoBlock extends Base {

	constructor (element, options = {}) {
		super(element, options = {});

		this.$playButton = this.$element.find(this.options.playbuttonselector);
		this.$closeButton = this.$element.find(this.options.closebuttonselector);
		this.$inlinePlayer = this.$element.find(this.options.inlineplayerselector);
		this.inlinePlayer = this.$inlinePlayer.get(0);
		this.watch();
		log('constructed', this);
	}

	watch () {
		this.$inlinePlayer.on('click', this.toggle.bind(this));
		this.$playButton.on('click', this.play.bind(this));
		this.$closeButton.on('click', this.stop.bind(this));
		log('watch', this);
	}

	stop () {
		log('stop', this);
		this.inlinePlayer.pause();
		this.inlinePlayer.currentTime = 0;
	}

	play () {
		log('play', this);
		this.inlinePlayer.play();
	}

	toggle () {
		log('toggle', this);
		if (this.inlinePlayer.paused) {
			this.inlinePlayer.play();
		} else {
			this.inlinePlayer.pause();
		}
	}

}

videoBlock.componentName = 'videoblock';


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/blocks/video/component.js